import React from 'react';
import Header from '../header';
import Footer from '../footer';
import { Content } from '../content';
import './Main.scss'


export default class Main extends React.Component {
  state = { currentSection: Content.sections[0], header: false };
  sections = [];
  scrollFrame = null;

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll);
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
    window.cancelAnimationFrame(this.scrollFrame);
  }

  handleScroll = () => {
    if (this.scrollFrame !== null) return;
    this.scrollFrame = window.requestAnimationFrame(() => {
      this.scrollFrame = null;
      let index = 0;
      this.sections.forEach((section, i) => {
        if (section && section.getBoundingClientRect().top <= window.innerHeight * 0.5) index = i;
      });
      const currentSection = Content.sections[index];
      const header = window.scrollY > 300;
      if (currentSection !== this.state.currentSection || header !== this.state.header) {
        this.setState({ currentSection, header });
      }
    });
  };

  render() {
    return (
      <div className="main">
        <div className="pre-header"></div>
        <Header name={Content.name} showing={this.state.header} />
        {Content.sections.map((section, i) => (
          <Section key={i} index={i}
            sectionRef={node => { this.sections[i] = node; }}
            display={section === this.state.currentSection ? 'visible' : 'hidden'} />
        ))}
        <Logos />
        <Footer />
      </div>
    );
  }
}

class Logos extends React.Component {
  render() {
    return (
      <div className="logos">
        <h2>Clients and collaborators</h2>
        <div className="logo-display">
          <img src="/assets/images/logos/wiley_logo.png" alt="Wiley" loading="lazy" decoding="async" />
          <img src="/assets/images/logos/vulcan_logo.png" alt="Vulcan" loading="lazy" decoding="async" />
          <img src="/assets/images/logos/bmnt.png" alt="BMNT" loading="lazy" decoding="async" />
          <img src="/assets/images/logos/hall-logo-reverse.png" alt="Lawrence Hall of Science" loading="lazy" decoding="async" />
          <img src="/assets/images/logos/igi_logo.png" alt="Innovative Genomics Institute" loading="lazy" decoding="async" />
          <img src="/assets/images/logos/hf.png" alt="High Fidelity" loading="lazy" decoding="async" />
          <img src="/assets/images/logos/spectrum_logo.png" alt="Spectrum" loading="lazy" decoding="async" />
          <img src="/assets/images/logos/UW_logo.png" alt="University of Washington" loading="lazy" decoding="async" />
          <img src="/assets/images/logos/duquesne_logo.png" alt="Duquesne University" loading="lazy" decoding="async" />
          <img src="/assets/images/logos/UCBerkeley.png" alt="UC Berkeley" loading="lazy" decoding="async" />
        </div>

      </div>
    )
  }
}

function Splash(props) {
  return (
    <div className={"splash "}>

      <img src={"/assets/images/" + Content.logo} alt="Dynamoid" width="401" height="239" />
      <h2 dangerouslySetInnerHTML={{ __html: props.description }}></h2>
      {/* <button>Go</button> */}
    </div>
  )
}


class Section extends React.Component {
  constructor(props) {
    super(props);
    const section = Content && Content.sections[this.props.index];
    this.state = {
      section: section,
      currentItem: 0,//default item is first
      timer: null,
      time: 0
    };
    this.incrementItem = this.incrementItem.bind(this);
  }
  componentDidMount() {
    // this.startAutoPlay();
  }
  componentWillUnmount() {
    // this.stopAutoPlay();

  }
  startAutoPlay() {
    this.setState({
      timer: setInterval(this.incrementItem, 15000)
    })
  }

  stopAutoPlay() {
    clearInterval(this.state.timer);
  }

  incrementItem() {
    if (this.state.currentItem == this.state.section.items.length - 1) {
      this.changeActiveItem(0);
    }
    else {
      this.changeActiveItem(this.state.currentItem + 1);
    }

  }

  itemButtonClicked(item) {
    this.stopAutoPlay();
    if (!this.checkIfCurrent(item)) {

      this.changeActiveItem(item);
      
    }
  }
  changeActiveItem(item) {
    this.setState({
      currentItem: item,
    });
  }

  getItems() {
    return this.state.section.items.map((item, i) =>

      <Item key={i} className="item" label={item.label} description={item.description} display={this.itemDisplayState(i)} image={item.image} preface={item.preface} onClick={() => this.itemClicked(i)} />

    );
  }

  getItemButtons() {
    return this.state.section.items.map((item, i) =>
      <ItemButton key={i} className="item-button" label={item.label} display={this.itemButtonDisplayState(i)} onClick={() => this.itemButtonClicked(i)} />
    );
  }

  getLinks() {

    if (this.state.section.tags) {
      return this.state.section.tags.map((tag, i) =>
        <LinkButton key={i} label={tag.label} url={tag.url} />
      )
    }
    else {
      return "";
    }

  }

  checkIfCurrent(item) {
    return item == this.state.currentItem;
  }

  itemDisplayState(item) {
    return this.checkIfCurrent(item) ? "visible" : "hidden";
  }

  itemButtonDisplayState(item) {
    return this.checkIfCurrent(item) ? "current" : "inactive";
  }

  getPreface() {
    let preface = this.state.section.preface;
    let image = this.state.section.image;
    let link = this.state.section.link;
    // console.log(preface);
    return preface ? (
      <div className="preface">
        {preface}
        <div>
        {/* {image && <img width="300" src={`assets/images/${image}`} />} */}
        {link && <button onClick={() => window.location = link } >Learn more</button>}
        </div>
      </div>
    ) : (
      ""
    );
  }


  render() {
    if (this.state.section.splash) {
      // console.log("IS SPLASH");
      return (
        <div ref={this.props.sectionRef}>
          <Background display={this.props.display} video={this.state.section.video} image={this.state.section.background} />
          <Splash description={this.state.section.description} />
        </div>
      )
    }


    const sectionClasses = "section " + this.props.display;

    let prefix = this.state.section.heading;
    let label = this.state.section.items[this.state.currentItem].label;

    if (isVowel(label.charAt(0)) && prefix.charAt(prefix.length - 1) == 'a') {
      prefix = prefix + "n";
    }


    else {
      return (
        <div ref={this.props.sectionRef}>
          <Background display={this.props.display} video={this.state.section.video} image={this.state.section.background} />

          <div className="section current">

            {this.getPreface()}

            <div className="label-prefix"><h2>{prefix}</h2></div>
            {this.getItemButtons()}
            <div className="section-content">




              <div>

                {this.getItems()}
              </div>

              <div className="links">
                {this.getLinks()}
              </div>



            </div>


          </div>
        </div>

      );
    }

  }
}

function isVowel(letter) {
  return (letter == "A" || letter == "E" || letter == "I" || letter == "O" || letter == "U");
}

class ItemButton extends React.Component {
  render() {
    return (
      <button type="button" className={"label " + this.props.display} aria-pressed={this.props.display === "current"} onClick={() => this.props.onClick()}><span>{this.props.label}</span></button>
    );
  }

}

class Item extends React.Component {


  render() {
    return (
      <div className={"item " + this.props.display}>
        {this.props.image ? <img src={"/assets/images/" + this.props.image} alt="" loading="lazy" decoding="async" /> : ""}
        <div className={"description " + this.props.display}>{this.props.description}</div>
      </div>

    );
  }
}


function LinkButton(props) {
  return (
    <div className="link" >
      <a href={props.url} target="_blank" rel="noopener noreferrer">{props.label}</a>
    </div>
  )
}



function VideoBackground(props) {
  // Hidden sections must not fetch or play their background movies.
  if (props.display !== 'visible') return null;
  const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  if (reducedMotion || saveData) return <ImageBackground display="visible" image="10k2.png" />;
  return (
    <div className="fullscreen-background visible" aria-hidden="true">
      <video src={'/assets/videos/' + props.video} loop muted autoPlay playsInline preload="none" className="video" />
    </div>
  );
}

function ImageBackground(props) {
  const optimized = props.image === '10k2.png';
  return (
    <div className={'fullscreen-background ' + props.display} aria-hidden="true">
      <img
        src={optimized ? '/assets/images/10k2-1920.webp' : '/assets/images/' + props.image}
        srcSet={optimized ? '/assets/images/10k2-960.webp 960w, /assets/images/10k2-1920.webp 1920w' : undefined}
        sizes={optimized ? '100vw' : undefined}
        width={optimized ? 1920 : undefined}
        height={optimized ? 1080 : undefined}
        alt="" decoding="async" fetchpriority="high"
      />
    </div>
  );
}

class Background extends React.Component {
  render() {
    if (this.props.video) {
      return (
        <VideoBackground display={this.props.display} video={this.props.video} />
      );
    }
    else if (this.props.image) {
      return (
        <ImageBackground display={this.props.display} image={this.props.image} />
      );
    }
    else {
      return (
        <div className="fullscreen-background">Missing background!</div>
      );
    }
  }
}
